import axios from 'axios';
import { getToken } from 'helpers';
import { API } from '../constants';
import { CatalogParams, Platform, CategoryKind } from '../types';
import { FormData } from '../components/NewAdForm/NewAdForm.types';
import { paramsSerializer } from '../utils';

export const axiosInstance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Csrf-Token': getToken()
  }
});

export const fetcher = async (url: string) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch data');
  }
};

export const categoryDataFetcher = async ([url, categoryId]: [string, CategoryKind]) => {
  try {
    const { data } = await axiosInstance.get(url, { params: { kind: categoryId } });
    return data;
  } catch (err: any) {
    throw new Error(err.response?.data?.message || 'Failed to load category data');
  }
};

export const fetchCatalogData = async (params: CatalogParams) => {
  try {
    const response = await axiosInstance.get(API.CATALOG, {
      params,
      paramsSerializer
    });
    return response.data;
  } catch {
    throw new Error('Failed to fetch catalog data');
  }
};

export const sendFormData = async (params: FormData, platformType: Platform) => {
  const payload = { auto: params };
  const response = await axiosInstance.post(API.NEW_AD, payload, {
    headers: {
      'X-Platform': platformType
    }
  });

  return response.data;
};

export const logout = async () => {
  try {
    const response = await axiosInstance.delete(API.LOGOUT);
    return response.data;
  } catch (error) {
    throw new Error('Failed to logout');
  }
};
